import { chain, sum, sumBy } from 'lodash';
const defaultOptions = {
    normalHitValue: 0.6,
    resolution: 64
};
export class Evaluator {
    timing;
    practice;
    _options;
    _hits = [];
    sigma;
    threshold;
    constructor(timing, practice, options) {
        this.timing = timing;
        this.practice = practice;
        this._options = { ...defaultOptions, ...options };
        this._hits = [];
        this.threshold = 1 / (this.timing.tickNote * 2);
        this.sigma = this.threshold / 2;
    }
    get hits() {
        return this._hits;
    }
    _push(...hits) {
        this._hits.push(...hits);
    }
    _reset() {
        this._hits = [];
    }
    snapHit = (hit) => {
        const position = this.timing.closestPosition(hit.timestamp);
        const tick = position.absTick;
        const dynamics = hit.value <= this.ghostHitValue ? 'ghost'
            : hit.value >= this.accentHitValue ? 'accent'
                : undefined;
        const note = {
            pitch: hit.note, sticking: undefined, dynamics,
            lag: position.lag / this.timing.tickNote
        };
        const lag = (this.timing.realValue(hit.timestamp) - position.realValue);
        return { tick, hit, position, note, lag };
    };
    get options() {
        return this._options;
    }
    get normalHitValue() {
        return this.options.normalHitValue;
    }
    get ghostHitValue() {
        return this.normalHitValue * 0.5;
    }
    get accentHitValue() {
        return this.normalHitValue * 1.2;
    }
    hitValue = (dynamics) => {
        switch (dynamics) {
            case 'ghost':
                return this.ghostHitValue;
            case 'accent':
                return this.accentHitValue;
            default:
                return this.normalHitValue;
        }
    };
    expectedValue = (dynamics) => {
        return dynamics == 'ghost' ? this.ghostHitValue :
            dynamics == 'accent' ? this.accentHitValue :
                this.normalHitValue;
    };
    scores = (evaluation) => evaluation.flatMap(tick => tick.evaluated.flatMap((hit) => ({
        ...hit,
        score: this.score(hit),
        maxScore: this.maxScore(hit),
        label: this.label(hit),
    })));
    summary = (evaluation) => {
        const scores = this.scores(evaluation);
        const score = sumBy(scores, 'score');
        const maxScore = sumBy(scores, 'maxScore');
        const categories = chain(scores)
            .groupBy('label')
            .mapValues(v => v.length).value();
        const improvables = chain(scores)
            .groupBy(s => s.lag != null
            ? s.lag == 0
                ? 'accurate' : s.lag < 0 ? 'early' : 'late'
            : s.label)
            .mapValues((s, label) => {
            const lost = s.map(s => s.maxScore - s.score);
            return sum(lost);
        })
            .pickBy(s => s > 0)
            .value();
        return {
            score, maxScore, categories, improvables
        };
    };
}
export function isMetronomeTick(tick) {
    return 'hits' in tick;
}
//# sourceMappingURL=Evaluator.js.map